module.exports = __webpack_public_path__ + "img/call-phone.ee2bab7c.svg";